import { render, staticRenderFns } from "./DataTableAcuerdosClientesBase.vue?vue&type=template&id=6fc0ec5d"
import script from "./DataTableAcuerdosClientesBase.vue?vue&type=script&lang=js"
export * from "./DataTableAcuerdosClientesBase.vue?vue&type=script&lang=js"
import style0 from "./DataTableAcuerdosClientesBase.vue?vue&type=style&index=0&id=6fc0ec5d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports